import { getFilledArrayOrDefault, isFilledArray } from "../../utils";
import { Related } from "./constants";

export interface StageAllocationRequest {
    layerId: string;
    stage: string;
    includeChildren?: boolean;
}

interface AllocatableLayer {
    id?: string | null;
    parents?: Related[] | null;
    latest_location?: { stage?: string | null } | null;
}

/**
 * The `POST /layers/{id}/locations` calls a check_location's
 * `allocate_to_stage` asks for when a check starts: the parents of the
 * configured types (with their children), or else the layer itself unless
 * it is already at that stage. Shared by the online start-check flow and
 * the offline replay, which evaluates it against the server's layer.
 */
export function stageAllocationRequests(
    stage: string | null | undefined,
    parentTypes: string[] | null | undefined,
    layer: AllocatableLayer,
): StageAllocationRequest[] {
    if (!stage || !layer.id) {
        return [];
    }

    const types = getFilledArrayOrDefault(parentTypes);
    const matchingParents = (isFilledArray(types) && isFilledArray(layer.parents))
        ? (layer.parents as Related[]).filter((p) => types.includes(p.type))
        : [];

    if (isFilledArray(matchingParents)) {
        return matchingParents.map((parent) => ({ layerId: parent.id, stage, includeChildren: true }));
    }
    if (stage === layer.latest_location?.stage) {
        return [];
    }
    return [{ layerId: layer.id, stage }];
}
